import { init as initApi } from "../../service/DataAnalysisService";

export const INIT_SUCCESS = "DATA_ANALYSIS_INIT_SUCCESS";
export const INIT_FAIL = "DATA_ANALYSIS_INIT_FAIL";

export const init = params => dispatch => {
  initApi(params).then(response => {
    dispatch({
      type: INIT_SUCCESS,
      payload: {
        grade: response.grade,
        class: response.classNumber,
        number: response.number,
        name: response.name,
        listName: response.listName,
        evaluationTerms: response.evaluationTerms,
        gradeList: response.gradeList,
        otherUserEvaluations: response.otherUserEvaluations,
        evaluationItems: response.evaluationItems,
        selfEvaluations: response.selfEvaluations,
        priorityTargets: response.priorityTargets
      }
    });
  });
};
